import { EventEmitter, Injectable } from '@angular/core';
import {
  KMTMessage,
  NotificationPayload,
} from '@core/models/global-entities/messages';
import { NavHeaderService } from './nav-header.service';

@Injectable({
  providedIn: 'root',
})
export class MessagingStoreService {
  private items: KMTMessage[] = [];
  public MessageCacheChanged = new EventEmitter();
  constructor(public navHeader: NavHeaderService) {}
  getMessages() {
    return this.items.slice();
  }
  incomingMessages(newMessages: NotificationPayload[]) {
    newMessages = newMessages || [];
    this.navHeader.hasUnread = newMessages.length > 0;
    this.items = newMessages
      .map((payload) => payload.payload)
      .concat(this.items);
    this.MessageCacheChanged.emit();
  }
  resetStore(newItems) {
    this.items = (newItems || []).slice();
  }
}
